import Abstract from '../../framework/Abstract';

import './E12-search-results.scss';

class E12SearchResults extends Abstract {
	init() {}
}

export default E12SearchResults;
